import { FormGroup, Text } from '@ksyos/design-system';
import { useMemo } from 'react';
import type { IOrthOProcedureCustomControlData } from '../../../../../common/interfaces/ophthalmology/orthO/orthOProcedureCustomControlData';
import type { ValidationErrors } from '../../../../utils/validation';
import { StyledBorderAndPadding } from '../../../elements/common';
import { InputText } from '../../../userDataManagement/InputText';

interface IOrthOV1ProcedureOdOsFindingsRowProps {
    customControlData: IOrthOProcedureCustomControlData;
    errors?: ValidationErrors;
    fieldKeyOd: keyof IOrthOProcedureCustomControlData;
    fieldKeyOs: keyof IOrthOProcedureCustomControlData;
    hasErrors?: boolean;
    isReadOnly?: boolean;
    label: string;
}

export function OrthOV1ProcedureOdOsFindingsRow(props: IOrthOV1ProcedureOdOsFindingsRowProps) {
    const showRow = useMemo(
        () =>
            !props.isReadOnly || props.customControlData[props.fieldKeyOd] || props.customControlData[props.fieldKeyOs],
        [props.isReadOnly]
    );

    return (
        <>
            {showRow && (
                <FormGroup
                    hasErrors={props.hasErrors}
                    label={props.label}
                >
                    <div className="row">
                        <div
                            className="col-sm-12"
                            style={{ minWidth: 240 }}
                        >
                            <StyledBorderAndPadding>
                                <Text
                                    fontWeight="bold"
                                    size="xs"
                                >
                                    OD
                                </Text>
                                <ReadOrEditInputField
                                    customControlData={props.customControlData}
                                    error={props.errors?.get(`customControlData.${props.fieldKeyOd}`)}
                                    fieldKey={props.fieldKeyOd}
                                    isReadOnly={props.isReadOnly}
                                    placeholder={'Bevindingen...'}
                                />
                            </StyledBorderAndPadding>
                        </div>
                        <div
                            className="col-sm-12"
                            style={{ minWidth: 240 }}
                        >
                            <StyledBorderAndPadding>
                                <Text
                                    fontWeight="bold"
                                    size="xs"
                                >
                                    OS
                                </Text>
                                <ReadOrEditInputField
                                    customControlData={props.customControlData}
                                    error={props.errors?.get(`customControlData.${props.fieldKeyOs}`)}
                                    fieldKey={props.fieldKeyOs}
                                    isReadOnly={props.isReadOnly}
                                    placeholder={'Bevindingen...'}
                                />
                            </StyledBorderAndPadding>
                        </div>
                    </div>
                </FormGroup>
            )}
        </>
    );
}

function ReadOrEditInputField(props: {
    customControlData: IOrthOProcedureCustomControlData;
    error?: string;
    fieldKey: keyof IOrthOProcedureCustomControlData;
    isReadOnly?: boolean;
    placeholder?: string;
}) {
    if (!props.isReadOnly) {
        return <InputText {...props} />;
    } else {
        return <>{props.customControlData[props.fieldKey] ?? ''}</>;
    }
}
